import ScopeConstants from "constants/ScopeConstants"

export const AuthenticationScope = {
    key: ScopeConstants.AUTHENTICATION,
    selector: (state) => state.authentication,
    tokenSelector: (state) => state.authentication.token
}